import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAASUlEQVR42mWKOQqAMBREc//b2aiF2thJQA3Zt8kCgQ+ZaWZ5DEQmaPz2pVNktO3PgpNvyNUTIJ3AwVfc3wXt5QzEFOqh+tnymAtS8H1Nw7EKFQAAAABJRU5ErkJggg=="};
